import { render, staticRenderFns } from "./SponsorshipForm.vue?vue&type=template&id=4b01885f&"
import script from "./SponsorshipForm.vue?vue&type=script&lang=js&"
export * from "./SponsorshipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports